export function arrayToTree(arr, idKey, parentKey, childrenKeyarr, rootId = '0') {
  const ar = []

  arr.forEach((it) => {
    // 当前元素是子元素
    if (it[parentKey] === rootId) {
      // 递归去找当前元素的子元素
      it[childrenKeyarr] = arrayToTree(arr, idKey, parentKey, childrenKeyarr, it[idKey])
      ar.push(it)
    }
  })

  return ar
}

export function convertToTree(data, parentId = null, childrenKey) {
  const tree = []

  for (const item of data) {
    if (item.parentId === parentId) {
      const children = convertToTree(data, item.id)
      if (children.length) {
        item[childrenKey] = children
      }
      tree.push(item)
    }
  }

  return tree
}

// /**
//  * 将数组转换为树状数据结构。
//  * @return {Array} - 转换后的树状数据结构。
//  */
// export function arrayToTree1(arr, id) {
//   const res = []
//   for (const item of arr) {
//     if (item.parentId === id) {
//       // 找到当前id的子元素
//       // 插入子元素，每个子元素的children通过回调生成
//       res.push({ ...item, childModuleMenus: arrayToTree1(arr, item.id) })
//     }
//   }
//   return res
// }
